import { invariant, isAliasedPropSchema, isPropSchema } from '../../utils/utils';
import { ChainedSchema } from '../general/ChainedSchema';
class SerializrType_alias extends ChainedSchema {
    name;
    constructor(name, propSchema) {
        super(propSchema);
        this.name = name;
    }
    get jsonname() {
        return this.name;
    }
}
export function alias(name, propSchema) {
    invariant(isPropSchema(propSchema), 'expected prop schema as second argument');
    invariant(!isAliasedPropSchema(propSchema), 'provided prop is already aliased');
    return new SerializrType_alias(name, propSchema);
}
